export default __webpack_public_path__ + "static/media/sale-icon.ec70d741.svg";